import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-913b2fee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "center-header" }
const _hoisted_3 = { class: "card-container" }
const _hoisted_4 = { class: "card-content" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "pagination" }
const _hoisted_7 = ["id"]
const _hoisted_8 = { class: "drawer-content" }
const _hoisted_9 = ["src"]

import { onBeforeMount, ref, watchEffect } from 'vue'
import { getMeeting } from '@/api/common'
import { ERR_SUCCESS } from '@/api/config'
import { CourseConfig } from '@/types'
import debounce from 'lodash/debounce'
import Pagination from '@/components/common/Pagination.vue'
import { ElMessage } from 'element-plus/lib'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const dataList = ref<CourseConfig[]>([])
const currentPage = ref<number>(1)
const pageSize = ref<number>(12)
const totalSize = ref<number>(0)
const keyInput = ref('')
const keyword = ref('')
const select = ref('theme')
const drawer = ref(false)
const drawerContent = ref('')
const drawerTitle = ref('')

async function fetchData () {
  try {
    const {
      code,
      result: {
        items: data,
        total
      }
    } = await getMeeting({
      params: {
        page: currentPage.value,
        pageSize: pageSize.value,
        [select.value]: keyword.value
      }
    })
    if (code === ERR_SUCCESS && data) {
      dataList.value = data
      totalSize.value = total
    }
  } catch (error) {
    console.error('Error fetching data:', error)
  }
}

function handleKeywordChange () {
  keyword.value = keyInput.value
}

const debouncedHandleKeywordChange = debounce(handleKeywordChange, 1000)

function openDrawer (liveUrl: string, replayUrl: string, theme: string, companyName: string) {
  let urlPart = ''
  const content = liveUrl || replayUrl
  if (content) {
    const liveMatch = content.match(/\/([^\/]+)\/index\.m3u8$/)
    if (liveMatch) {
      urlPart = liveMatch[1]
    }
  }

  if (urlPart) {
    drawerContent.value = `https://iclasscloud.cretech.cn/livecloudm/lib/playvideo.html?play=https://playback.cretech.cn/${urlPart}/index.m3u8`
    drawerTitle.value = `${theme} - ${companyName}`
    drawer.value = true
  }
}

function handleDrawerClose () {
  drawerContent.value = ''
}

const copyLink = () => {
  // 创建一个临时的 input 元素
  const input = document.createElement('input')
  input.value = drawerContent.value
  document.body.appendChild(input)
  input.select()
  input.setSelectionRange(0, 9999)
  const successful = document.execCommand('copy')
  document.body.removeChild(input)
  if (successful) {
    ElMessage.success('链接已复制到剪贴板！')
  } else {
    ElMessage.error('链接复制失败')
  }
}

onBeforeMount(() => fetchData())

watchEffect(() => fetchData())


return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Search = _resolveComponent("Search")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_CircleCloseFilled = _resolveComponent("CircleCloseFilled")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_input, {
        modelValue: keyInput.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((keyInput).value = $event)),
        class: "input-with-select",
        clearable: "",
        placeholder: "关键词 ...",
        onInput: _unref(debouncedHandleKeywordChange)
      }, {
        prepend: _withCtx(() => [
          _createVNode(_component_el_select, {
            modelValue: select.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((select).value = $event)),
            placeholder: "Select",
            style: {"width":"115px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: "主题",
                value: "theme"
              }),
              _createVNode(_component_el_option, {
                label: "内容",
                value: "content"
              }),
              _createVNode(_component_el_option, {
                label: "单位",
                value: "company_name"
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        append: _withCtx(() => [
          _createVNode(_component_el_icon, {
            type: "button",
            onClick: handleKeywordChange
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Search)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "onInput"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataList.value, (item, index) => {
        return (_openBlock(), _createBlock(_component_el_card, {
          key: index,
          class: "data-card",
          shadow: "hover"
        }, {
          footer: _withCtx(() => [
            (item.liveurl || item.replay_url)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "primary",
                  onClick: ($event: any) => (openDrawer(item.liveurl, item.replay_url, item.theme, item.company_name))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("查看 ")
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", null, [
                _createTextVNode("主题: "),
                _createVNode(_component_el_text, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.theme), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              (item.content)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createTextVNode("摘要: "),
                    _createVNode(_component_el_text, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.content), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", null, [
                _createTextVNode("单位: "),
                _createVNode(_component_el_text, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.company_name), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _createElementVNode("div", null, [
                _createTextVNode("日期: "),
                _createVNode(_component_el_text, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.flag), 1)
                  ]),
                  _: 2
                }, 1024)
              ])
            ])
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_el_link, {
        href: "https://iclasscloud.cretech.cn/livecloudceshi/index.html",
        target: "_blank"
      }, {
        default: _withCtx(() => [
          _createTextVNode("官网 ")
        ]),
        _: 1
      }),
      _createVNode(Pagination, {
        "current-page": currentPage.value,
        "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((currentPage).value = $event)),
        "page-size": pageSize.value,
        "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((pageSize).value = $event)),
        "total-size": totalSize.value
      }, null, 8, ["current-page", "page-size", "total-size"])
    ]),
    _createVNode(_component_el_drawer, {
      modelValue: drawer.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((drawer).value = $event)),
      size: 1200,
      "with-header": true,
      direction: "btt",
      onClosed: handleDrawerClose
    }, {
      header: _withCtx(({ close, titleId, titleClass }) => [
        _createElementVNode("h4", {
          id: titleId,
          class: _normalizeClass(titleClass)
        }, _toDisplayString(drawerTitle.value), 11, _hoisted_7),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: copyLink
        }, {
          default: _withCtx(() => [
            _createTextVNode("拷贝链接")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "danger",
          onClick: close
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, { class: "el-icon--left" }, {
              default: _withCtx(() => [
                _createVNode(_component_CircleCloseFilled)
              ]),
              _: 1
            }),
            _createTextVNode(" Close ")
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          (drawerContent.value)
            ? (_openBlock(), _createElementBlock("iframe", {
                key: 0,
                src: drawerContent.value,
                allowfullscreen: "",
                height: "100%",
                width: "100%"
              }, null, 8, _hoisted_9))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})